// マニフェスト添付ファイル用
export const MANIFEST_ATTACHMENT = {
  MAX_SIZE: 3,
  MAX_FILE_SIZE: 5000000,
  ALT_FILE_SIZE_FORMAT: '5MB',
  ALT_FILE_FORMAT: '.jpg .jpeg .png .pdf',
  ACCEPTS: ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'],
  IMMEDIATE_DELETE: false
}
